import React from "react";
import PropTypes from "prop-types";
import styles from "./AddressItem.module.css";
import { AddressInfoItem } from "../AddressInfoItem/AddressInfoItem";
import { RadioButton } from "../RadioButton/RadioButton";
import { Toggler } from "../Toggler/Toggler";
import { Button } from "../Button/Button";
import { TrashButton } from "../TrashButton/TrashButton";
import { useTranslation } from "react-i18next";

export function AddressItem({
  addressInfo,
  defaultSelected,
  setDefault,
  primary,
  setPrimary,
  onEdit,
  onDelete,
  isTogglerDisabled,
}) {
  const {t} = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.address}>
        <AddressInfoItem
          address={addressInfo}
          labelColor={"#91B6BB"}
          isInModal={false}
        />
      </div>
      <div className={styles.defaultContainer}>
        <div className={styles.radioButton}>
          <RadioButton
            isSelected={defaultSelected}
            value={t("Set as my default shipping address")}
            onChange={setDefault}
          />
        </div>

        <div className={styles.bottomRow}>
          <div className={styles.toggler}>
            <label className={styles.togglerLabel}>{t("Primary")}</label>
            <Toggler
              toggled={primary}
              onChange={() => {
                setPrimary(!primary);
              }}
              color={primary ? "#39B54A" : "#D3D3D3"}
              visible={true}
              readOnly={false}
              // disabled={false}
              disabled={isTogglerDisabled}
            />
          </div>
          <Button
            buttonText={t("Edit")}
            onClick={() => onEdit(addressInfo.iboAddressId)}
            className={styles.editButton}
            disabled={false}
          />
          <div className={styles.trashButton}>
            <TrashButton
              onClick={onDelete}
              disabled={addressInfo.primary === 1 ? true : false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

AddressItem.propTypes = {
  addressInfo: PropTypes.shape({
    recipient: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
    country: PropTypes.string,
  }),
  defaultSelected: PropTypes.bool,
  setDefault: PropTypes.func,
  primary: PropTypes.bool,
  setPrimary: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default AddressItem;
